// export const basciUrl = 'https://api.apimanageaz.xyz'
export const basciUrl = 'https://api.apimanageeb.xyz'